<section
  class="toggle-form"
  [ngClass]="{ active: isBulkUserUpdateSliderOpen }"
>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"> </p-confirmDialog>
  <div class="formwrap">
    <div class="Header">
      <h1>
        <b>{{ topBarTitle }}</b>
      </h1>
      <p-button
        appPreventDoubleClick
        styleClass="p-button-text"
        id="bulkUserScopeSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSliderWithConfirmation()"
      ></p-button>
    </div>

    <div class="general-container content">
      <form [formGroup]="bulkUserScopeForm" (ngSubmit)="submitBulkUserScopeForm()">
        <div class="form-container">
          <div class="field">
            <bpt-dropdown
              label="Add as Primary eQMS Scope for Users"
              [options]="filteredPrimaryUsers"
              [editable]="false"
              tooltipPosition="left"
              [multiSelect]="true"
              formControlName="addAsPrimaryUsers"
              [selectionLimit]= 100
              id="addAsPrimaryUsers"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              pTooltip="Maximum of 100 users can be selected at a time."
              [showToggleAll]="false"
            >
            </bpt-dropdown>
          </div>

          <div class="field">
            <bpt-dropdown
              label="Add as Other eQMS Scope for Users"
              [options]="filteredOtherUsers"
              [editable]="false"
              [multiSelect]="true"
              [selectionLimit]="100"    
              formControlName="addAsOtherUsers"
              id="addAsOtherUsers"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              pTooltip="Maximum of 100 users can be selected at a time."
              tooltipPosition="left"
              [showToggleAll]="false"
            >
            </bpt-dropdown>
          </div>

          <div class="field">
            <bpt-dropdown
              label="Remove from Other eQMS Scope for Users"
              [options]="filteredRemoveUsers"
              [editable]="false"
              [multiSelect]="true"
               [selectionLimit]="100" 
              formControlName="removeFromOtherUsers"
              id="removeFromOtherUsers"
              [showClear]="true"
              [showFilter]="true"
              [valueField]="valueField"
              [labelField]="labelField"
              pTooltip="Maximum of 100 users can be selected at a time."
              tooltipPosition="left"
              [showToggleAll]="false"
            >
            </bpt-dropdown>
          </div>

          <div class="button-container">
            <p-button
              appPreventDoubleClick
              type="submit"
              label="Save"
              id="bulkUserScopeSaveButton"
              class="align-right"
              styleClass="bpt-button-compact"
              [disabled]="!hasSelection || isLoadingUsers || isSubmitting"
              (debounceClick)="submitBulkUserScopeForm()"
            ></p-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

